import React from 'react';
import FocusTrap from '../../../../javascript/utils/modal-focus-trap.js';

export class FocusFirst extends React.Component {
  constructor(...args) {
    super(...args);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentDidUpdate = this.componentDidUpdate.bind(this);
    this.focusFirst = this.focusFirst.bind(this);
    this.setRef = this.setRef.bind(this);
  }

  static initClass() {
    this.defaultProps = {
      delay: 0,
      restoreLostFocus: false
    };
  }

  componentDidMount() {
    return setTimeout((() => this.focusFirst()), this.props.delay);
  }

  componentDidUpdate(prevProps) {
    if (!this.props.restoreLostFocus) { return; }

    if (!this._ref.contains(document.activeElement)) {
      return setTimeout((() => this.focusFirst()), 0);
    }
  }

  focusFirst() {
    if (!this._ref) { return false; }

    const elements = FocusTrap.focusableDescendants(this._ref);
    for (let i = 0, end = elements.length - 1; i <= end; i++) {
      const target = elements[i];

      try {
        target.focus();
      } catch (e) {
        true;
      }

      if (document.activeElement === target) { return true; }
    }
    return false;
  }


  setRef(ref) { return this._ref = ref; }

  render() {
    return <div ref={this.setRef}>
      {this.props.children}
    </div>;
  }
}
FocusFirst.initClass();
